import { useCountDown } from 'ahooks'
import { FormattedRes } from 'ahooks/lib/useCountDown'
import dayjs, { unix } from 'dayjs'
import { useMemo, useState } from 'react'

export type ActivityState = 'upcoming' | 'on_going' | 'ended'

export const getActivityStatus = (startAt: number, endAt: number): ActivityState => {
  // console.log('>> time: ', unix(startAt).unix(), unix(endAt).unix(), dayjs().unix())
  if (unix(startAt).isAfter(dayjs())) {
    return 'upcoming'
  }
  if (unix(endAt).isBefore(dayjs())) {
    return 'ended'
  }
  return 'on_going'
}

const useActivityState = ({
  startAt,
  endAt,
  onStart,
  onEnd,
}: {
  startAt: number
  endAt: number
  onStart?: () => void
  onEnd?: () => void
}) => {
  const [activityState, setActivityState] = useState(getActivityStatus(startAt, endAt))

  const [, startTimeFormattedRes] = useCountDown({
    targetDate: activityState === 'upcoming' ? startAt * 1000 : undefined,
    onEnd() {
      setActivityState('on_going')
      onStart?.()
      // console.log('>>>> startAt onEnd')
    },
  })
  const [, endTimeFormattedRes] = useCountDown({
    targetDate: activityState === 'on_going' ? endAt * 1000 : undefined,
    onEnd() {
      setActivityState('ended')
      onEnd?.()
      // console.log('>>>> endAt onEnd')
    },
  })

  const formattedResMap: Record<ActivityState, FormattedRes | null> = useMemo(
    () => ({
      upcoming: startTimeFormattedRes,
      on_going: endTimeFormattedRes,
      ended: null,
    }),
    [endTimeFormattedRes, startTimeFormattedRes],
  )

  const formattedRes = formattedResMap[activityState]

  return { activityState, formattedRes }
}
export default useActivityState
